// CEW is a legacy Toronto warehouse that was fully replaced by TC. Project
// docs still carry it in their `warehouses` array, which leaks a dead row
// into inventory UIs and confuses the destination-suffix heuristic. Treat
// it as if it doesn't exist for any UI purpose.
const LEGACY_WAREHOUSE_CODES = new Set(["CEW"]);

function codeOf(warehouse) {
  return typeof warehouse === "string" ? warehouse : warehouse?.letterCode;
}

export function filterLegacyWarehouses(warehouses) {
  if (!Array.isArray(warehouses)) return warehouses;
  return warehouses.filter((w) => !LEGACY_WAREHOUSE_CODES.has(codeOf(w)));
}

export function toWarehouseCodes(warehouses) {
  if (!Array.isArray(warehouses)) return [];
  return warehouses
    .map(codeOf)
    .filter((c) => c && !LEGACY_WAREHOUSE_CODES.has(c));
}
